export const FB_PIXEL_ID = '939527124870639';

export const initFBPixel = () => {
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
            n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    window.fbq('init', FB_PIXEL_ID);
    window.fbq('track', 'PageView');
};

export const pageView = () => {
    window.fbq('track', 'PageView');
};

export const viewContent = (data) => {
    window.fbq('track', 'ViewContent', data);
};

export const addToCart = (data) => {
    window.fbq('track', 'AddToCart', data);
};

export const initiateCheckout = (data) => {
    window.fbq('track', 'InitiateCheckout', data);
};

export const purchase = (data) => {
    window.fbq('track', 'Purchase', data);
};
